import settings from '@/settings'

const todas = (headers, data) => {
  let url = `${settings.apetrusApi}/carteiravirtual/todas/`
  if (data) {
    const keys = Object.keys(data)
    for (let i = 0; i < keys.length; i++) {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${data[keys[i]]}`
    }
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

export default {
  todas
}
